/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';
import { IPanelDataFacade } from '../../../../../data-access/src/lib/domain/facades-models/panel-data-facade-interface';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { SelectedPanelDataItem } from '../../models/selected-panel-data-item';
import { PanelDataService } from '../../../../../utils/src/lib/sysque-backend/panel-data.service';
import { LocalStorageService } from '../../../../../utils/src/lib/local-storage/local-storage.service';
import { ApplyPanelDataState } from './panel-data-reducer';
import {
  ChangeApplyPanelDialogSize,
  ValidatePanelCircuitData,
} from './panel-data-actions';
import {
  selectValidElementSelection,
} from './panel-data-selector';
import { ReceiveMessageHandler } from '@mep/web-browser-bridge';
import { ApplyPanelDataReceiveController } from '../../receive-controllers/apply-paneldata-receive-controller';
import { CircuitList } from '../../models/paneldata-info';
import { PanelCircuitDataReturnCodes } from '../../models/panel-circuit-data-return-codes';

@Injectable({
  providedIn: 'root',
})
export class PanelDataFacade implements IPanelDataFacade {
  constructor(
    private panelStore: Store<ApplyPanelDataState>,
    private panelDataService: PanelDataService,
    private readonly receiveMessageHandler: ReceiveMessageHandler,
    private localStorageService: LocalStorageService
  ) {
    this.receiveMessageHandler.registerController(new ApplyPanelDataReceiveController(this.localStorageService));
  }

  public applyPanelData(item: SelectedPanelDataItem): Observable<any> {
    return this.panelDataService.ApplyPanelData(item);
  }

  public localStorageUpdate(key: string, value: any): void {
    this.localStorageService.updateStorage(key, value);
  }

  public localStorageGetItem(key: string): string {
    return this.localStorageService.getStorage(key);
  }

  public windowResize(height: number): void {
    this.panelStore.dispatch(ChangeApplyPanelDialogSize({ height: height }));
  }

  public closeWindow(): Observable<boolean> {
    return this.panelDataService.OnCloseWindow();
  }

  public validateSelection(): Observable<PanelCircuitDataReturnCodes> {
    this.panelStore.dispatch(ValidatePanelCircuitData());
    return this.panelStore.select(selectValidElementSelection);
  }

  public initializeProjectData(): Promise<string[]> {
     return this.panelDataService.getProjectData();
  }

  public getPanelData(projectName: string, initialize: boolean): Promise<string[]> {
    return this.panelDataService.getPanelData(projectName, initialize);
  }

  public getCircuitData(projectName: string, panelName: string): Promise<CircuitList[]> {
    return this.panelDataService.getCircuitData(projectName, panelName);
  }
}
